module.exports = __webpack_public_path__ + "img/description.11329210.png";